import { z } from 'zod';
import { SearchSchema } from '@anytag/shared-validations';
import { YoutubeAnalyticsPostsSortOrder } from '@anytag/graphql';
import { defaultProfilePostsFilterSchema } from '@anytag/shared-organisms';

export const AnalyticsYtVideosSearchSchema = SearchSchema.create({
  filter: defaultProfilePostsFilterSchema,
  sort: { field: YoutubeAnalyticsPostsSortOrder }
});

export type AnalyticsYtVideosSearchSchemaType = z.infer<typeof AnalyticsYtVideosSearchSchema>;
